import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthProvider";
import { canAccessRole } from "./roles";
import type { UserRole } from "./roles";

type RequireRoleProps = {
  allowedRoles: UserRole[];
  children: React.ReactNode;
};

const RequireRole: React.FC<RequireRoleProps> = ({ allowedRoles, children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div style={{ padding: 32, fontSize: 14 }}>
        Checking permissions...
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (!canAccessRole(user.role, allowedRoles)) {
    return (
      <div style={{ padding: 32 }}>
        <h2 style={{ margin: 0, fontSize: 20 }}>Access denied</h2>
        <p style={{ marginTop: 8, fontSize: 14 }}>
          Your account does not have access to this page.
        </p>
      </div>
    );
  }

  return <>{children}</>;
};

export default RequireRole;

